document.addEventListener('DOMContentLoaded', function() {
  // Bulk Order Logic
  const bulkForm = document.getElementById('bulk-order-form');
  if (bulkForm) {
    // Track added items
    let addedItems = [];

    // Re-query inputs since they might be added dynamically if we had filters
    const getInputs = () => bulkForm.querySelectorAll('.bulk-qty-input');
    const totalDisplay = document.getElementById('bulk-grand-total');
    const searchInput = document.getElementById('bulk-search');
    const searchSubmit = document.querySelector('.bulk-search-submit');
    const getRows = () => Array.from(bulkForm.querySelectorAll('#bulk-product-list tr[data-variant-id]'));
    const paginationRow = document.querySelector('#bulk-product-list tr[data-bulk-pagination-row]');
    const emptyStateRow = document.getElementById('bulk-empty-state');
    const categoryButtons = Array.from(document.querySelectorAll('.bulk-category-link'));
    const addedItemsToggle = document.getElementById('bulk-added-items-toggle');
    const addedItemsPopup = document.getElementById('bulk-added-items-popup');
    const addedItemsList = document.getElementById('bulk-added-items-list');
    const addedItemsPreview = document.getElementById('bulk-added-items-preview');
    const addedItemsSummary = document.getElementById('bulk-added-items-summary');
    let activeCategory = categoryButtons[0]?.dataset.categoryHandle || 'all';

    // Toggle added items popup
    if (addedItemsSummary) {
      addedItemsSummary.addEventListener('click', function(e) {
        e.stopPropagation();
        addedItemsPopup.classList.toggle('active');
        addedItemsSummary.classList.toggle('active');
      });
    }

    // Close popup when clicking outside
    document.addEventListener('click', function(e) {
      if (addedItemsPopup && addedItemsPopup.classList.contains('active')) {
        if (!e.target.closest('.bulk-added-items')) {
          addedItemsPopup.classList.remove('active');
          if (addedItemsSummary) {
            addedItemsSummary.classList.remove('active');
          }
        }
      }
    });

    // Update added items display
    function updateAddedItemsDisplay() {
      if (!addedItemsList || !addedItemsPreview) return;

      // Update preview text
      if (addedItems.length === 0) {
        addedItemsPreview.textContent = 'No items added';
      } else {
        const mostRecent = addedItems[addedItems.length - 1];
        const itemTitle = mostRecent.variant
          ? `${mostRecent.title} (${mostRecent.variant})`
          : mostRecent.title;

        if (addedItems.length === 1) {
          addedItemsPreview.textContent = itemTitle;
        } else {
          addedItemsPreview.textContent = `${itemTitle} + ${addedItems.length - 1} more`;
        }
      }

      // Update popup list
      if (addedItems.length === 0) {
        addedItemsList.innerHTML = '<div class="bulk-added-items-empty">No items added yet</div>';
        return;
      }

      // Show most recent items first (reverse order)
      const displayItems = [...addedItems].reverse();

      addedItemsList.innerHTML = displayItems.map((item, index) => {
        const originalIndex = addedItems.length - 1 - index;
        let imageHtml = '';
        
        if (item.image) {
          if (item.image.includes('<svg')) {
            imageHtml = `<div class="bulk-added-item-image placeholder-svg-wrapper">${item.image}</div>`;
          } else {
            imageHtml = `<img src="${item.image}" alt="${item.title}" class="bulk-added-item-image">`;
          }
        } else {
          imageHtml = `<div class="bulk-added-item-image placeholder-image"></div>`;
        }

        return `
          <div class="bulk-added-item">
            ${imageHtml}
            <div class="bulk-added-item-details">
              <div class="bulk-added-item-title">${item.title}</div>
              ${item.variant ? `<div class="bulk-added-item-variant">${item.variant}</div>` : ''}
              <div class="bulk-added-item-qty">Qty: ${item.quantity}</div>
            </div>
            <button class="bulk-added-item-remove" data-index="${originalIndex}" aria-label="Remove item">
              <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
              </svg>
            </button>
          </div>
        `;
      }).join('');

      // Add remove button listeners
      addedItemsList.querySelectorAll('.bulk-added-item-remove').forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          const index = parseInt(this.dataset.index);
          removeAddedItem(index);
        });
      });

      // Add click listener to highlight table row
      addedItemsList.querySelectorAll('.bulk-added-item').forEach((item, index) => {
        item.addEventListener('click', function(e) {
          if (e.target.closest('.bulk-added-item-remove')) return;

          const originalIndex = addedItems.length - 1 - index;
          const variantItem = addedItems[originalIndex];
          if (!variantItem) return;

          // Find and highlight the table row
          const row = document.querySelector(`tr[data-variant-id="${variantItem.variantId}"]`);
          if (row) {
            // Remove previous highlights
            document.querySelectorAll('tr.highlighted').forEach(r => {
              r.classList.remove('highlighted');
            });

            // Add highlight
            row.classList.add('highlighted');
            row.scrollIntoView({ behavior: 'smooth', block: 'center' });

            // Remove highlight after 2 seconds
            setTimeout(() => {
              row.classList.remove('highlighted');
            }, 2000);
          }

          // Close popup
          addedItemsPopup.classList.remove('active');
          addedItemsSummary.classList.remove('active');
        });
      });
    }

    // Remove item from added items
    function removeAddedItem(index) {
      const item = addedItems[index];
      if (!item) return;

      // Find corresponding input and set to 0
      const input = document.querySelector(`.bulk-qty-input[data-id="${item.variantId}"]`);
      if (input) {
        input.value = 0;
        updateTotals();
      }

      // Remove from array
      addedItems.splice(index, 1);
      updateAddedItemsDisplay();
    }

    // Add item to tracking
    function trackAddedItem(variantId, quantity, shouldUpdate = true) {
      const row = document.querySelector(`tr[data-variant-id="${variantId}"]`);
      if (!row) return;

      const title = row.querySelector('.bulk-product-title')?.textContent || '';
      const variant = row.querySelector('.bulk-variant-title')?.textContent || '';
      const img = row.querySelector('.bulk-product-image');
      let image = '';

      if (img) {
        if (img.tagName.toLowerCase() === 'svg' || img.classList.contains('placeholder-svg')) {
          image = img.outerHTML;
        } else {
          image = img.src || '';
        }
      }

      const price = row.querySelector('[data-price]')?.textContent || '';

      // Check if item already exists
      const existingIndex = addedItems.findIndex(item => item.variantId === variantId);

      if (existingIndex !== -1) {
        // Update existing item
        if (quantity > 0) {
          addedItems[existingIndex].quantity = quantity;
        } else {
          // Remove if quantity is 0
          addedItems.splice(existingIndex, 1);
        }
      } else if (quantity > 0) {
        // Add new item
        addedItems.push({
          variantId,
          title,
          variant,
          image,
          price,
          quantity
        });
      }

      if (shouldUpdate) {
        updateAddedItemsDisplay();
      }
    }

    // Calculate totals
    function updateTotals() {
      let grandTotal = 0;
      let totalItems = 0;
      const inputs = getInputs();

      inputs.forEach(input => {
        const qty = parseInt(input.value) || 0;
        const variantId = parseInt(input.dataset.id);
        const row = input.closest('tr');
        if (!row) return;

        if (qty > 0) {
          const priceElement = row.querySelector('[data-price]');
          if (!priceElement) return;
          const price = parseFloat(priceElement.dataset.price);
          const rowTotal = qty * price;

          // Update row total display
          const rowTotalDisplay = row.querySelector('.row-total');
          if (rowTotalDisplay) rowTotalDisplay.textContent = formatMoney(rowTotal);

          grandTotal += rowTotal;
          totalItems += qty;

          // Track added item without immediate display update
          trackAddedItem(variantId, qty, false);
        } else {
          const rowTotalDisplay = row.querySelector('.row-total');
          if (rowTotalDisplay) rowTotalDisplay.textContent = formatMoney(0);

          // Remove from tracking if qty is 0
          const existingIndex = addedItems.findIndex(item => item.variantId === variantId);
          if (existingIndex !== -1) {
            addedItems.splice(existingIndex, 1);
          }
        }
      });

      // Update footer
      if (totalDisplay) totalDisplay.textContent = formatMoney(grandTotal);
      
      // Update display once after all items are processed
      updateAddedItemsDisplay();
    }

    function applyProductFilters() {
      const term = (searchInput?.value || '').trim().toLowerCase();
      let visibleCount = 0;

      getRows().forEach(row => {
        const text = row.innerText.toLowerCase();
        const categories = (row.dataset.productCategories || '')
          .split(',')
          .map(value => value.trim())
          .filter(Boolean);
        const matchesSearch = !term || text.includes(term);
        const matchesCategory = activeCategory === 'all' || categories.includes(activeCategory);
        const shouldShow = matchesSearch && matchesCategory;

        row.style.display = shouldShow ? '' : 'none';
        if (shouldShow) visibleCount += 1;
      });

      if (emptyStateRow) {
        emptyStateRow.hidden = visibleCount !== 0;
      }

      if (paginationRow) {
        paginationRow.style.display = visibleCount === 0 || term || activeCategory !== 'all' ? 'none' : '';
      }
    }

    // Input listeners (using delegation for better performance and future-proofing)
    bulkForm.addEventListener('input', function(e) {
      if (e.target.classList.contains('bulk-qty-input')) {
        updateTotals();
      }
    });

    bulkForm.addEventListener('change', function(e) {
      if (e.target.classList.contains('bulk-qty-input')) {
        updateTotals();
      }
    });

    // Search functionality
    if (searchInput) {
      const searchClear = document.getElementById('bulk-search-clear');

      if (searchSubmit) {
        searchSubmit.addEventListener('click', function() {
          searchInput.focus();
        });
      }

      searchInput.addEventListener('input', function(e) {
        const term = e.target.value.toLowerCase();

        // Show/hide clear button
        if (term.length > 0) {
          searchClear.style.display = 'flex';
        } else {
          searchClear.style.display = 'none';
        }

        applyProductFilters();
      });

      // Clear search
      searchClear.addEventListener('click', function(e) {
        searchInput.value = '';
        searchClear.style.display = 'none';
        applyProductFilters();
        searchInput.focus();
      });

      // Prevent form submission on Enter key
      searchInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });

      // Prevent form submission
      searchInput.addEventListener('submit', function(e) {
        e.preventDefault();
        return false;
      });
    }

    if (categoryButtons.length) {
      categoryButtons[0].classList.add('is-active');

      categoryButtons.forEach(button => {
        button.addEventListener('click', function() {
          activeCategory = this.dataset.categoryHandle || 'all';

          categoryButtons.forEach(item => {
            item.classList.toggle('is-active', item === this);
          });

          applyProductFilters();
        });
      });
    }

    applyProductFilters();

    // Add to Cart
    bulkForm.addEventListener('submit', function(e) {
      e.preventDefault();

      const items = [];
      getInputs().forEach(input => {
        const qty = parseInt(input.value) || 0;
        if (qty > 0) {
          items.push({
            id: parseInt(input.dataset.id),
            quantity: qty
          });
        }
      });

      if (items.length === 0) {
        alert('Please select at least one item.');
        return;
      }

      addToCart(items, true, null, addedItems);
    });
  }

  // Quick Shop Logic (Grid)
  const quickShopGrid = document.querySelector('.quick-shop-grid');
  if (quickShopGrid) {
    // Auto-select variant if only one available option
    const variantSelects = quickShopGrid.querySelectorAll('select.quick-shop-variants');
    variantSelects.forEach(select => {
      // Count available options (excluding disabled options and empty value options)
      const availableOptions = Array.from(select.options).filter(option =>
        option.value && !option.disabled
      );

      // If only one available option, auto-select it
      if (availableOptions.length === 1) {
        select.value = availableOptions[0].value;
        // Trigger change event in case other scripts need to react
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    quickShopGrid.addEventListener('click', function(e) {
      // Handle clicks on Add buttons
      const addBtn = e.target.closest('.quick-shop-add-btn');
      if (addBtn) {
        e.preventDefault();
        e.stopPropagation();

        const card = addBtn.closest('.quick-shop-card');
        const variantSelect = card.querySelector('select.quick-shop-variants');
        const variantInput = card.querySelector('.quick-shop-variant-input');
        const qtyInput = card.querySelector('.bulk-qty-input');

        let variantId = null;

        // Try to get variant ID from different sources
        if (variantSelect && variantSelect.value) {
          variantId = variantSelect.value;
        } else if (variantInput) {
          variantId = variantInput.value;
        } else if (addBtn.dataset.variantId) {
          variantId = addBtn.dataset.variantId;
        }

        const qty = parseInt(qtyInput.value) || 1;

        if (!variantId) {
          alert('Please select a variant');
          return;
        }

        addToCart([{ id: parseInt(variantId), quantity: qty }], false, addBtn);
      }
    });
  }

  // Helper: Format Money
  function formatMoney(cents) {
    // 1. Try theme's global formatMoney
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents, window.Shopify?.money_format);
    }

    // 2. Try Shopify's formatMoney
    if (window.Shopify && window.Shopify.formatMoney) {
      let formatted = window.Shopify.formatMoney(cents, window.Shopify.money_format);
      // Ensure commas for thousands separator if missing
      if (formatted && !formatted.includes(',')) {
        const parts = formatted.split(/\.|,/);
        if (parts[0]) {
          const integerPart = parts[0].replace(/\D/g, '');
          parts[0] = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          formatted = parts.join('.');
        }
      }
      return formatted;
    }

    // 3. Fallback
    let format = window.Shopify && window.Shopify.money_format ? window.Shopify.money_format : "${{amount}}";
    let value = (cents / 100).toFixed(2);

    // Add thousands separator
    let [dollars, cents_part] = value.split('.');
    dollars = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    value = dollars + (cents_part ? '.' + cents_part : '');

    return format.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_no_decimals\s*\}\}/, parseInt(value));
  }

  // Helper: Add to Cart API
  function addToCart(items, isBulk = false, triggerBtn = null, addedItemsArray = null) {
    const btn = triggerBtn || document.querySelector('#bulk-order-form button[type="submit"]');
    if (!btn) return;

    const originalText = btn.innerText;
    btn.innerText = 'Adding...';
    btn.disabled = true;
    btn.classList.add('loading');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(data => {
      btn.innerText = 'Added!';
      btn.classList.remove('loading');
      btn.classList.add('success');

      // Trigger cart drawer update using Minimog theme's event system
      if (window.MinimogEvents) {
        window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, data);
      }

      // Also update the cart drawer directly
      const cartDrawer = document.querySelector('m-cart-drawer');
      if (cartDrawer && typeof cartDrawer.onCartDrawerUpdate === 'function') {
        cartDrawer.onCartDrawerUpdate();
      }

      setTimeout(() => {
        btn.innerText = originalText;
        btn.disabled = false;
        btn.classList.remove('success');

        if (isBulk) {
          const inputs = document.querySelectorAll('.bulk-qty-input');
          inputs.forEach(input => {
            input.value = 0;
            // Trigger input event to reset row totals
            input.dispatchEvent(new Event('input', { bubbles: true }));
          });
          const totalDisplay = document.getElementById('bulk-grand-total');
          if (totalDisplay) totalDisplay.textContent = formatMoney(0);

          // Clear added items array
          if (addedItemsArray && Array.isArray(addedItemsArray)) {
            addedItemsArray.length = 0;
            const addedItemsList = document.getElementById('bulk-added-items-list');
            const addedItemsPreview = document.getElementById('bulk-added-items-preview');
            if (addedItemsList) {
              addedItemsList.innerHTML = '<div class="bulk-added-items-empty">No items added yet</div>';
            }
            if (addedItemsPreview) {
              addedItemsPreview.textContent = 'No items added';
            }
          }
        }
      }, 2000);
    })
    .catch((error) => {
      console.error('Error:', error);
      alert('Error adding to cart. Please try again.');
      btn.innerText = originalText;
      btn.disabled = false;
      btn.classList.remove('loading');
    });
  }
});
